import { Phone, Mail, Clock } from "lucide-react";
import { CONTACT } from "@/lib/site-data";

export const Topbar = () => (
  <div data-testid="topbar" className="bg-[#14171a] text-white/80 text-xs sm:text-sm">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-10 gap-4">
      <div className="flex items-center gap-5 min-w-0">
        <a data-testid="topbar-phone" href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 hover:text-white transition-colors duration-200">
          <Phone size={13} className="text-[#e2001a]" />
          <span className="hidden sm:inline">{CONTACT.phone}</span>
          <span className="sm:hidden">Anrufen</span>
        </a>
        <a data-testid="topbar-email" href={`mailto:${CONTACT.email}`} className="hidden md:flex items-center gap-2 hover:text-white transition-colors duration-200">
          <Mail size={13} className="text-[#e2001a]" />
          {CONTACT.email}
        </a>
      </div>
      <div className="flex items-center gap-2 text-white/60">
        <Clock size={13} className="text-[#e2001a]" />
        <span data-testid="topbar-hours">{CONTACT.hours}</span>
      </div>
    </div>
  </div>
);
